<template>
  <div v-if="unfiledIncidents.length > 0" class="unfiled-incidents">
    <h2>
      <font-awesome-icon fixed-width icon="person-burst" />
      Reports that need to be filed
    </h2>
    <file-challenging-behaviour-report-modal />
    <div class="activities-container">
      <div
        v-for="unfiledIncident in unfiledIncidents"
        :key="unfiledIncident.id"
        class="activity-container"
      >
        <template
          v-for="client in get(unfiledIncident, 'clients', [])"
          :key="client.id"
        >
          <template
            v-for="(report, index) in get(client, 'reports', [])"
            :key="index"
          >
            <unfiled-client-incident-report-card
              v-if="
                report.event === 'BEHAVIOUR' &&
                has(report, 'incident') &&
                !has(report, 'incident.reportFiled')
              "
              :activity="unfiledIncident"
              :client="client"
              :behaviour-report="report"
              class="me-2"
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeMount, onBeforeUnmount, onMounted } from "vue";
import { useStore } from "vuex";
import get from "lodash/get";
import has from "lodash/has";
import { Hub } from "aws-amplify/utils";
import UnfiledClientIncidentReportCard from "./UnfiledClientIncidentReportCard.vue";
import FileChallengingBehaviourReportModal from "@/components/activity/modal/FileChallengingBehaviourReportModal.vue";

export default {
  components: {
    UnfiledClientIncidentReportCard,
    FileChallengingBehaviourReportModal,
  },
  setup() {
    const store = useStore();

    const unfiledIncidents = ref([]);

    function findIncidents() {
      store
        .dispatch(`rotaactivities/getUnfiledIncidentReports`)
        .then((data) => {
          if (data !== false) {
            unfiledIncidents.value = get(data, "_embedded.rota-activities", []);
          }
        });
    }

    /*
      If we receive an activity update, requery for unfiled incidents
    */
    let activityListenerCancel;
    onBeforeUnmount(() => {
      activityListenerCancel();
    });
    onBeforeMount(() => {
      activityListenerCancel = Hub.listen("activity", ({ payload }) => {
        switch (payload.event) {
          case "updated":
            findIncidents();
            break;
          default:
        }
      });
    });
    onMounted(() => {
      findIncidents();
    });

    return {
      unfiledIncidents,
      get,
      has,
    };
  },
};
</script>
